import React, { useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import Button from '../../../utils/components/Button/Button';
import { deleteAdminCampaign, getAllCampaignAdmin } from "../../actions/adminCampaignsActions";
import { Table } from '../Table/Table';

const ManageCampaigns = ({ history }) => {

  const dispatch = useDispatch();
  const { listCampaigns } = useSelector((state) => state.adminCampaignsList);

  useEffect(() => {
    dispatch(getAllCampaignAdmin())
  }, []);
  console.log();
  return (
    <div>
      <div>Administrar campañas</div>
      <Table>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Fecha de Creación</th>
            <th>Descripción</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {listCampaigns !== null ? listCampaigns.map((item) => (
            <tr key={item._id}>
              <td>{item.name}</td>
              <td>{new Date(item.initDate).toLocaleDateString()}</td>
              <td>{item.description}</td>
              <td>
               <div className='column centerContent'>
               <Button onClick={() => (
                  dispatch(deleteAdminCampaign(item._id, listCampaigns.findIndex(element => element._id === item._id)))
                )} text="Eliminar" />

                <Button onClick={() => history.push("/Admin/EditAdminCampaigns/" + item._id)} text="Editar" />
               </div>
              </td>
            </tr>
          )) : ''}
        </tbody>

      </Table>

    </div>

  )
}

export default ManageCampaigns